<template>
  <div id="app">
    <header class="site-header">
      <b-navbar toggleable="lg" class="cbp-nav">
        <b-container>
          <b-navbar-brand :to="'/'" class="brand">
            <img src="@/assets/logo_cbp.png" alt="Club Baby Pro" class="brand-logo" />
            <span class="brand-name">Club Baby Pro</span>
          </b-navbar-brand>

          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav class="mx-auto">
              <b-nav-item to="/" exact class="nav-link-cbp">{{ languages[language].home }}</b-nav-item>
              <b-nav-item to="/hotpursuit" class="nav-link-cbp">Hot Pursuit</b-nav-item>
              <b-nav-item to="/laowai-survival" class="nav-link-cbp">Laowai Survival</b-nav-item>
              <b-nav-item to="/stellar-collect" class="nav-link-cbp">Stellar Collect</b-nav-item>
            </b-navbar-nav>

            <b-navbar-nav>
              <b-nav-item-dropdown right class="lang-dropdown">
                <template #button-content>
                  <span class="lang-current">{{ language.toUpperCase() }}</span>
                </template>
                <b-dropdown-item @click="changeLanguage('fr')">FR — Français</b-dropdown-item>
                <b-dropdown-item @click="changeLanguage('en')">EN — English</b-dropdown-item>
              </b-nav-item-dropdown>
            </b-navbar-nav>
          </b-collapse>
        </b-container>
      </b-navbar>
    </header>

    <main class="site-main">
      <router-view />
    </main>

    <footer class="site-footer">
      <b-container>
        <div class="footer-inner">
          <div class="footer-brand">
            <img src="@/assets/logo_cbp.png" alt="Club Baby Pro" class="footer-logo" />
            <div>
              <p class="footer-title">Club Baby Pro</p>
              <p class="footer-sub">Studio de jeux indépendant</p>
            </div>
          </div>

          <div class="footer-social">
            <b-link
              href="https://play.google.com/store/apps/details?id=com.ClubBabyPro.HotPursuit"
              target="_blank" rel="noopener noreferrer" aria-label="Google Play" class="social-link">
              <font-awesome-icon :icon="['fab', 'google-play']" />
            </b-link>
            <b-link
              href="mailto:club.babypro@gmail.com"
              aria-label="Email" class="social-link">
              <font-awesome-icon :icon="['fa', 'envelope']" />
            </b-link>
          </div>
        </div>

        <div class="footer-bottom">
          <p>© {{ year }} Club Baby Pro. Tous droits réservés.</p>
          <router-link to="/privacy" class="footer-legal">Politique de confidentialité</router-link>
        </div>
      </b-container>
    </footer>
  </div>
</template>

<script>
import en from '@/en'
import fr from '@/fr'

export default {
  data () {
    return {
      year: new Date().getFullYear(),
      languages: {
        en,
        fr
      }
    }
  },
  computed: {
    language () {
      return this.$store.state.language
    }
  },
  methods: {
    changeLanguage (lang) {
      this.$store.commit('changeLanguage', lang)
    }
  }
}
</script>

<style lang="scss">
  #app {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  .site-main {
    flex: 1;
  }

  /* ---------- Header / Navbar ---------- */
  .site-header {
    position: sticky;
    top: 0;
    z-index: 1000;
  }

  .cbp-nav {
    background: rgba(255, 255, 255, 0.78);
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);
    border-bottom: 1px solid var(--border);
    box-shadow: 0 4px 20px -12px rgba(20, 28, 45, 0.25);
    padding-top: 0.6rem;
    padding-bottom: 0.6rem;
  }

  .brand {
    display: inline-flex;
    align-items: center;
    gap: 0.7rem;
  }

  .brand-logo {
    height: 42px;
    width: auto;
    transition: transform 0.25s ease;
  }
  .brand:hover .brand-logo {
    transform: scale(1.06) rotate(-3deg);
  }

  .brand-name {
    font-family: 'agency', sans-serif;
    font-size: 1.6rem;
    font-weight: 700;
    color: var(--text);
    letter-spacing: 1px;
  }

  .cbp-nav .nav-link-cbp .nav-link {
    font-family: 'agency', sans-serif;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    font-size: 1.15rem;
    color: var(--text-muted) !important;
    padding: 0.35rem 0.25rem;
    margin: 0 0.6rem;
    position: relative;
  }
  .cbp-nav .nav-link-cbp .nav-link::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -2px;
    height: 2px;
    width: 0;
    background: linear-gradient(90deg, var(--gold), var(--gold-600));
    transition: width 0.25s ease;
  }
  .cbp-nav .nav-link-cbp .nav-link:hover,
  .cbp-nav .nav-link-cbp .nav-link.router-link-active {
    color: var(--text) !important;
  }
  .cbp-nav .nav-link-cbp .nav-link:hover::after,
  .cbp-nav .nav-link-cbp .nav-link.router-link-active::after {
    width: 100%;
  }

  /* Dropdown langue */
  .cbp-nav .lang-dropdown .nav-link {
    color: var(--text) !important;
    font-family: 'agency', sans-serif;
    border: 1px solid var(--border-strong);
    border-radius: 999px;
    padding: 0.25rem 0.85rem !important;
    letter-spacing: 1px;
  }
  .cbp-nav .lang-dropdown .dropdown-menu {
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    box-shadow: var(--shadow-card);
  }
  .cbp-nav .lang-dropdown .dropdown-item {
    color: var(--text-muted);
  }
  .cbp-nav .lang-dropdown .dropdown-item:hover {
    background: var(--surface-2);
    color: var(--gold);
  }

  .cbp-nav .navbar-toggler {
    border-color: var(--border-strong);
  }
  .cbp-nav .navbar-toggler-icon {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(24,32,49,0.8)' stroke-width='2' stroke-linecap='round' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
  }

  /* ---------- Footer ---------- */
  .site-footer {
    background: var(--surface-2);
    border-top: 1px solid var(--border);
    padding: 2.5rem 0 1.75rem;
    margin-top: 2rem;
  }

  .footer-inner {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 1.5rem;
  }

  .footer-brand {
    display: flex;
    align-items: center;
    gap: 0.9rem;
    text-align: left;
  }
  .footer-logo {
    height: 46px;
    width: auto;
  }
  .footer-title {
    font-family: 'agency', sans-serif;
    font-size: 1.35rem;
    font-weight: 700;
    margin: 0;
    color: var(--text);
  }
  .footer-sub {
    margin: 0;
    color: var(--text-muted);
    font-size: 0.9rem;
  }

  .footer-social {
    display: flex;
    gap: 0.75rem;
  }
  .social-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 12px;
    background: var(--surface);
    border: 1px solid var(--border);
    color: var(--text-muted);
    font-size: 1.25rem;
    transition: transform 0.2s ease, color 0.2s ease, border-color 0.2s ease;
  }
  .social-link:hover {
    color: var(--gold);
    border-color: var(--gold);
    transform: translateY(-3px);
  }

  .footer-bottom {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
    margin-top: 1.75rem;
    padding-top: 1.25rem;
    border-top: 1px solid var(--border);
    color: var(--text-muted);
    font-size: 0.88rem;
  }
  .footer-bottom p {
    margin: 0;
  }
  .footer-legal {
    color: #15803d;
    text-decoration: none;
    font-weight: 600;
  }
  .footer-legal:hover,
  .footer-legal:focus {
    color: var(--gold);
    text-decoration: none;
  }

  @media (max-width: 575px) {
    .footer-inner,
    .footer-bottom {
      flex-direction: column;
      text-align: center;
    }
    .footer-brand {
      flex-direction: column;
      text-align: center;
    }
  }
</style>
